import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import DateReservationList from 'components/Lists/DateReservationList'
import CreateDateReservationModal from 'pages/Modals/CreateDateReservationModal'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'
import { Container, Row } from '../../styles'
import SecondaryButton from 'components/Buttons/SecondaryButton'

export default function EditDateReservations ({
  reservationType = 'cutilei'
}) {
  const [loading, setLoading] = useState (true)
  const [reservations, setReservations] = useState ([])
  const [showCreateReservationModal, setShowCreateReservationModal] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [reservationType])

  const getData = async () => {
    try {
      setLoading (true)
      const { data: reservations } = await cutileiApi.get (
        `/businesses/${businessId}/date_reservations?type=${reservationType}`,
        requestConfig
      )
      setReservations (reservations)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const compareReservations = (a, b) => (
    DateTime.fromISO (a.start_date).toMillis () - DateTime.fromISO (b.start_date).toMillis ()
  )

  const handleCreateReservation = reservation => {
    setReservations ([...reservations, reservation].sort (compareReservations))
  }

  const handleEditReservation = reservation => {
    setReservations (reservations.map (r => r.id === reservation.id ? {...reservation} : r))
  }

  const handleDeleteReservation = reservation => {
    setReservations (reservations.filter (r => r.id !== reservation.id))
  }

  const toggleCreateReservationModal = () => setShowCreateReservationModal (!showCreateReservationModal)

  if (loading) return <Loading style={{marginTop: 30}}/>

  return (
    <Container style={{paddingTop: 10}}>
      {AuthService.hasPermission ('business_config.agenda', 'edit') && (
        <Row>
          <SecondaryButton
            label='Criar reserva'
            onClick={toggleCreateReservationModal}
            width={140}
          />
          <CreateDateReservationModal
            visible={showCreateReservationModal}
            reservationType={reservationType}
            onClose={toggleCreateReservationModal}
            onConfirm={handleCreateReservation}
          />
        </Row>
      )}
      {loading ? <Loading/> : (
        <DateReservationList
          reservations={reservations}
          onEdit={handleEditReservation}
          onDelete={handleDeleteReservation}
        />
      )}
    </Container>
  )
}
